var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"fill-height grayscale lighten-6",attrs:{"fluid":""}},[_c('nuxt')],1)],1),_vm._v(" "),_c('core-notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }